import { type FC } from 'react';
import { Paper, SimpleGrid, Stack, Text, UnstyledButton } from '@mantine/core';
import { IconCreditCard, IconCreditCardPay, IconMenu2 } from '@tabler/icons-react';
import { Link, useLocation } from 'react-router';
import { routes } from '~/shared/constants/routes';
import styles from './MobileFooterNav.module.css';

export interface MobileFooterNavProps {
    opened: boolean;
    onNavigate?: VoidFunction;
    onMoreClick: VoidFunction;
}

export const MobileFooterNav: FC<MobileFooterNavProps> = ({ opened, onNavigate, onMoreClick }) => {
    const { pathname } = useLocation();
    const isPayinActive = pathname === routes.payin;
    const isPayoutActive = pathname === routes.payout;

    return (
        <Paper
            component='nav'
            aria-label='Мобильная навигация'
            bg='var(--mantine-color-default)'
            className={styles.root}
            radius={0}
        >
            <SimpleGrid
                className={styles.grid}
                cols={3}
                spacing={0}
            >
                <UnstyledButton
                    component={Link}
                    className={styles.item}
                    to={routes.payout}
                    onClick={onNavigate}
                    aria-current={isPayoutActive ? 'page' : undefined}
                    data-active={isPayoutActive || undefined}
                >
                    <Stack
                        align='center'
                        gap={3}
                    >
                        <IconCreditCardPay
                            className={styles.icon}
                            stroke={1.8}
                            aria-hidden='true'
                        />

                        <Text
                            component='span'
                            className={styles.label}
                        >
                            Выплаты
                        </Text>
                    </Stack>
                </UnstyledButton>

                <UnstyledButton
                    component={Link}
                    className={styles.item}
                    to={routes.payin}
                    onClick={onNavigate}
                    aria-current={isPayinActive ? 'page' : undefined}
                    data-active={isPayinActive || undefined}
                >
                    <Stack
                        align='center'
                        gap={3}
                    >
                        <IconCreditCard
                            className={styles.icon}
                            stroke={1.8}
                            aria-hidden='true'
                        />

                        <Text
                            component='span'
                            className={styles.label}
                        >
                            Приём
                        </Text>
                    </Stack>
                </UnstyledButton>

                <UnstyledButton
                    className={styles.item}
                    onClick={onMoreClick}
                    type='button'
                    aria-pressed={opened}
                    data-active={opened || undefined}
                >
                    <Stack
                        align='center'
                        gap={3}
                    >
                        <IconMenu2
                            className={styles.icon}
                            stroke={1.8}
                            aria-hidden='true'
                        />

                        <Text
                            component='span'
                            className={styles.label}
                        >
                            Ещё
                        </Text>
                    </Stack>
                </UnstyledButton>
            </SimpleGrid>
        </Paper>
    );
};
